
import { mapState } from 'vuex'
import DropdownBgDecor from './DropdownBgDecor.vue'
import { RoutesListFn } from '@/router'
import allUrls from '@/utils/config'
import { getConsignMethods } from '@/utils/consign-methods'
import UsOrderModal from '@/modules/templates/default/consign/components/usOrder.vue'
export default {
  components: { UsOrderModal, DropdownBgDecor },
  data() {
    return {
      RoutesList: RoutesListFn(this.$route.params.site),
      moduleName: 'home',
      site: this.$route.params.site,
      lang: this.$route.params.lang,
      curSubItemName: '', // 当前选中的二级菜单
      current: -1,
      doNotDisplayIndex: [0, 1, 2, 6],
    }
  },
  computed: {
    ...mapState({
      isAgree: (state) => state.cookie_agree.agree,
      cookieBtnDisagree: (state) => state.cookie_btn_disagree,
      locale: (state) => state.locale,
      isHdFtMobile: (state) => state.isHdFtMobile,
    }),
    isCollapsed() {
      return this.isAgree || this.cookieBtnDisagree
    },
    getSubItem() {
      const lang = this.$route.params.lang

      return (subItem) => {
        return (
          subItem?.children.filter((item) => {
            return !item?.hidden?.hiddenLangList?.includes(lang)
          }) || []
        )
      }
    },
    consignIuopLink() {
      return allUrls.iuoploginUrl
    },
    consignWxLink() {
      return allUrls.ciosActivity
    },
    consignMethods() {
      return getConsignMethods(this.site, (key) => this.$t(key), {
        lang: this.lang,
      })
    },
  },
  mounted() {},
  created() {
    this.setDefaultActive()
  },
  methods: {
    switchItem(switchKey) {
      if (process.client && switchKey) {
        return window?.[switchKey] || false
      }
      return false
    },
    setDefaultActive() {
      // 选中
      const fullPath = this.$route.path
      const path = fullPath.split('?')[0]
      const moduleName = path.split('/')[3]
      this.moduleName = moduleName || 'home'
    },
    openDropDown(e, item, index) {
      this.current = index
      // const rect = e.target?.getBoundingClientRect()
      if (item?.children?.length > 0) {
        this.curSubItemName = item.children[0].name
        this.$nextTick(() => {
          // const dom = e.target.querySelector('.sub_list')
          // if (dom) dom.style.left = `-${rect.left}px`
        })
      } else {
        // this.$nextTick(() => {
        //   const wrap = e.target.querySelector('.checkList_content_wrap')
        //   if (wrap) wrap.style.left = `-${rect.left}px`
        // })
      }
    },
    changeCurSubItemName(item) {
      this.curSubItemName = item.name
    },
    closeDropDown(e, item) {
      this.curSubItemName = ''
      this.current = -1
    },
    // 新加坡 联系我们 点击跳转
    contactClick(menuItem) {
      this.$router.replace({
        path: `/${this.$route.params.site}/${this.$route.params.lang}${menuItem.path}`,
      })
    },
    isNoSgContact(menuItem) {
      return this.site === 'sg' && menuItem.name === 'contact'
    },
    isCurrentRoute(link) {
      const currentPath = this.$route.path.split('?')[0]
      const pathSegments = currentPath.split('/')
      const routePath = '/' + pathSegments.slice(3).join('/')
      if (routePath !== link.path) return false
      // If link has query params, compare them too
      if (link.params && link.params.query) {
        const currentQuery = this.$route.query || {}
        return Object.entries(link.params.query).every(
          ([k, v]) => currentQuery[k] === v
        )
      }
      return true
    },
    getSupportGroups(menuItem) {
      // Group support children into columns:
      //   Items with children (querySupport, customsClearance) → their own column
      //   Flat items (termsOfUse, privacyPolicy, faq, suggestion) → "其他" column
      const children = menuItem.children || []
      const groups = []

      children.forEach((child) => {
        if (child.children && child.children.length > 0) {
          groups.push({
            il8nName: child.il8nName,
            cname: child.cname,
            children: child.children,
            path: child.path,
            params: child.params,
            customLink: child.customLink,
          })
        } else {
          let otherGroup = groups.find((g) => g._isOther)
          if (!otherGroup) {
            otherGroup = {
              il8nName: 'navs.other',
              cname: '其他',
              children: [],
              _isOther: true,
            }
            groups.push(otherGroup)
          }
          otherGroup.children.push(child)
        }
      })

      return groups
    },
    flattenGroup(group) {
      if (group.children && group.children.length > 0) {
        return group.children
      }
      return [group]
    },
    // 物流服务：将 children 按分组整理为多列
    getProductGroups(menuItem) {
      const children = menuItem.children || []
      return children.map((child) => {
        if (child.children && child.children.length > 0) {
          // 有子分类的（如物流产品 → 快递/电商）
          return {
            il8nName: child.il8nName,
            cname: child.cname,
            path: child.path,
            params: child.params,
            children: child.children,
          }
        }
        // 无子分类的直接展示
        return {
          il8nName: child.il8nName,
          cname: child.cname,
          path: child.path,
          params: child.params,
          children: [child],
        }
      })
    },
    // 物流服务：展开子项链接（处理 hasNext 的嵌套结构）
    getProductLinks(group) {
      const links = []
      ;(group.children || []).forEach((item) => {
        if (item.children && item.children.length > 0) {
          // 嵌套子项（如 快递 → 国际标快/国际特惠）
          item.children.forEach((sub) => {
            links.push({
              path: sub.path,
              params: sub.params,
              customLink: sub.customLink,
              il8nName: sub.il8nName,
              cname: sub.cname,
              highlight: sub.highlight,
            })
          })
        } else {
          links.push({
            path: item.path,
            params: item.params,
            customLink: item.customLink,
            il8nName: item.il8nName,
            cname: item.cname,
            highlight: item.highlight,
          })
        }
      })
      return links
    },
    // 关于我们：将 children 按分组整理为多列
    getAboutGroups(menuItem) {
      const children = menuItem.children || []
      return children.map((child) => {
        if (child.children && child.children.length > 0) {
          return {
            il8nName: child.il8nName,
            cname: child.cname,
            children: child.children.map((sub) => ({
              path: sub.path,
              params: sub.params,
              customLink: sub.customLink,
              il8nName: sub.il8nName,
              cname: sub.cname,
            })),
          }
        }
        // 无子分类的叶子项（如联系我们）或外链（如商务合作）
        return {
          il8nName: child.il8nName,
          cname: child.cname,
          children: [
            {
              path:
                child.path && !child.path.startsWith('http') ? child.path : '',
              params: child.params,
              customLink: child.customLink,
              externalUrl:
                child.path && child.path.startsWith('http') ? child.path : '',
              il8nName: child.il8nName,
              cname: child.cname,
            },
          ],
        }
      })
    },
    // 打开外部链接（寄件方式中的 externalLink）
    openExternal(url) {
      if (process.client && url) {
        window.open(url, '_blank')
      }
    },
    // 寄件方式按钮点击处理（美加站弹窗，其他站外链）
    handleMethodBtnClick(method) {
      if (method.showUsOrderModal) {
        this.$refs.usOrderRef?.openDialog()
      } else if (method.externalLink) {
        this.openExternal(method.externalLink)
      }
    },
  },
}
